import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import WhyChooseOne from "../component/whychoose/WhyChooseOne";
import ProjectOne from "../component/project/ProjectOne";
import TeamOne from "../component/team/TeamOne";
import SplashBanner from "../component/banner/SplashBanner";
import ContactLocation from "../component/contact/ContactLocation";
import SectionTitle from "../elements/section-title/SectionTitle";

const OurOffice = () => {
  return (
    <>
      <SEO title="Our Office" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerOne
          title="Our Office"
          paragraph="This is the place weher we create best solution for you with our experienced Team Member"
          styleClass="thumbnail-4"
          mainThumb="/images/banner/office.png"
        />
        <div className="section section-padding bg-color-dark overflow-hidden" style={{marginTop: 150}}>
          <div className="container">
            <SectionTitle
              subtitle="Find Us"
              title="Our offices"
              description=""
              textAlignment="heading-light-left"
              textColor=""
            />
            <div className="row">
              <ContactLocation />
            </div>
          </div>
          <ul className="shape-group-11 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
                alt="line"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                alt="line"
              />
            </li>
          </ul>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default OurOffice;
